// src/App.tsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';

import Layout from './components/Layout';

import HomeContent from './pages/HomeContent';
import LoginPage from './pages/LoginPage';

import Dashboard from './pages/Dashboard';

// Cadastros
import PessoasPage from './pages/cadastros/PessoasPage';
import LigacoesPage from './pages/cadastros/LigacoesPage';
import UsuariosPage from './pages/cadastros/UsuariosPage';
import FaixasExcessoPage from './pages/cadastros/FaixasExcessoPage';

// Manutenções
import LeiturasPage from './pages/manutencoes/LeiturasPage';
import MovimentosPage from './pages/manutencoes/MovimentosPage';
import ReciboAvulsoPage from './pages/manutencoes/ReciboAvulsoPage';

// Relatórios
import RelPessoasPage from './pages/relatorios/PessoasPage';
import RelLigacoesPage from './pages/relatorios/LigacoesPage';
import RelMovimentosPage from './pages/relatorios/MovimentosPage';

import NotFound from './pages/NotFound';

const PrivateRoute: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return <>{children}</>;
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route element={<Layout />}>
            {/* Rotas públicas */}
            <Route path="/" element={<HomeContent />} />
            <Route path="/login" element={<LoginPage />} />

            {/* Rotas protegidas */}
            <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />

            {/* Cadastros */}
            <Route path="/cadastros/pessoas" element={<PrivateRoute><PessoasPage /></PrivateRoute>} />
            <Route path="/cadastros/ligacoes" element={<PrivateRoute><LigacoesPage /></PrivateRoute>} />
            <Route path="/cadastros/usuarios" element={<PrivateRoute><UsuariosPage /></PrivateRoute>} />
            <Route path="/cadastros/tarifas" element={<PrivateRoute><FaixasExcessoPage /></PrivateRoute>} />

            {/* Manutenções */}
            <Route path="/manutencoes/leituras" element={<PrivateRoute><LeiturasPage /></PrivateRoute>} />
            <Route path="/manutencoes/movimentos" element={<PrivateRoute><MovimentosPage /></PrivateRoute>} />
            <Route path="/manutencoes/recibo-avulso" element={<PrivateRoute><ReciboAvulsoPage /></PrivateRoute>} />

            {/* Relatórios */}
            <Route path="/relatorios/pessoas" element={<PrivateRoute><RelPessoasPage /></PrivateRoute>} />
            <Route path="/relatorios/ligacoes" element={<PrivateRoute><RelLigacoesPage /></PrivateRoute>} />
            <Route path="/relatorios/consumo" element={<PrivateRoute><RelMovimentosPage /></PrivateRoute>} />
            <Route path="/relatorios/faturamento" element={<PrivateRoute><RelMovimentosPage /></PrivateRoute>} />

            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
